import { forwardRef, type Ref, type SVGProps } from "react";
const IconNotePlusOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m29.04 19.88-.23-.14C27.76 19.13 26 18.11 26 14V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-2h2a2 2 0 0 0 2-2v-.42a1.97 1.97 0 0 0-.96-1.7M24 26H4v-4.92a9.44 9.44 0 0 0 3.63 2.85A.9.9 0 0 0 8 24h16zm4-4H8.21A7.59 7.59 0 0 1 4 15V6h20v8c0 3.22.96 5.03 2 6.11a7.5 7.5 0 0 0 1.8 1.36l.2.11z"
    />
    <path
      fill="currentColor"
      d="M18 13h-3v-3a1 1 0 0 0-2 0v3h-3a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconNotePlusOutlineSVG);
ForwardRef.displayName = "IconNotePlusOutline";
export { ForwardRef as IconNotePlusOutline };
